import { createFileRoute } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { PageHero } from "@/components/site/PageShell";
import { BUSINESS } from "@/components/site/constants";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Destination Roofing Inc." },
      { name: "description", content: "How Destination Roofing Inc. collects, uses, and protects information submitted through our website and contact forms." },
      { property: "og:title", content: "Privacy Policy | Destination Roofing Inc." },
      { property: "og:description", content: "Privacy practices for Destination Roofing Inc." },
      { property: "og:url", content: canonical("/privacy-policy") },
    ],
    links: [{ rel: "canonical", href: canonical("/privacy-policy") }],
  }),
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <>
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="How we handle information you share with us." />
      <section className="mx-auto max-w-3xl px-4 py-12 md:py-16 prose prose-slate">
        <p><strong>Effective date:</strong> January 1, 2025</p>

        <h2>Who we are</h2>
        <p>
          Destination Roofing Inc. is a family-owned, licensed and insured roofing contractor
          serving Citrus County, Florida. Florida Roofing Contractor License {BUSINESS.license}.
          You can reach us at {BUSINESS.phone} or {BUSINESS.email}.
        </p>

        <h2>Information we collect</h2>
        <p>
          When you submit a request through our website (for example, our Free Roof Inspection form),
          we collect the information you provide: name, phone number, email address, service address,
          the service you're interested in, and any message you include. We also collect basic technical
          information such as the page you submitted from and the date and time of submission.
        </p>

        <h2>How we use your information</h2>
        <ul>
          <li>To contact you about your roof inspection request and provide an estimate.</li>
          <li>To schedule and perform roofing work you request.</li>
          <li>To respond to questions you send us by phone, email, or web form.</li>
          <li>To improve our website and services.</li>
        </ul>
        <p>We do not sell your personal information.</p>

        <h2>Analytics and advertising</h2>
        <p>
          We use Google Analytics 4 and Google Ads conversion tracking to understand how visitors
          use our site and to measure the performance of our advertising. These services may set
          cookies and collect anonymous usage data such as pages visited, device type, and
          approximate location.
        </p>

        <h2>How we share information</h2>
        <p>
          We share information only with service providers who help us operate our business
          (for example, our email delivery provider and our website hosting provider), and only to
          the extent needed to deliver the service. We may also disclose information if required by
          law.
        </p>

        <h2>Data retention</h2>
        <p>
          We keep lead submissions for as long as needed to complete the requested work and to
          comply with our record-keeping obligations, then we delete them.
        </p>

        <h2>Your choices</h2>
        <p>
          You can ask us to update or delete information you've submitted by contacting us at
          {" "}{BUSINESS.email} or {BUSINESS.phone}.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The effective date at the top of
          this page will reflect the most recent revision.
        </p>

        <h2>Contact</h2>
        <p>
          Destination Roofing Inc.<br />
          Phone: <a href={BUSINESS.phoneHref}>{BUSINESS.phone}</a><br />
          Email: <a href={BUSINESS.emailHref}>{BUSINESS.email}</a>
        </p>
      </section>
    </>
  );
}
